import React from "react";
import styled from "styled-components";
import  speakers from "../../../utils/keynotespeakers.js";
import IUMRSNavBar from "./IUMRSNavbar.jsx";
import { ICAMNavroute } from "../../../utils/ICAMnavroute.js";
import IUMRSFooter from "./IUMRSFooter";


const KeynoteSpeakers = () => {

  return (
    <Container>

      <IUMRSNavBar navroute={ICAMNavroute}/>

      <MaxWidth>
        <Header>
          <Title>Keynote <Highlight>Speakers</Highlight></Title>
          <Subtitle>
            Featured talks from leading researchers and innovators
          </Subtitle>
        </Header>

        <Grid>
          {speakers.map((speaker, index) => (
            <SpeakerCard key={index}>
              <Number>{index + 1 < 10 ? `0${index+1}` : index+1}</Number>

              <SpeakerName>{speaker.name}</SpeakerName>
              <Institution>{speaker.institution}</Institution>
              <TopicLabel>Presentation Topic</TopicLabel>
              <Topic>{speaker.topic}</Topic>
            </SpeakerCard>
          ))}
        </Grid>
      </MaxWidth>

      <IUMRSFooter />
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%);
`;

const MaxWidth = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 80px;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: #082D4A;
  margin-bottom: 16px;
  letter-spacing: -1px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Highlight = styled.span`
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
    height: 12px;
    background: rgba(8, 45, 74, 0.15);
    z-index: -1;
  }
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #4a5f7a;
  font-weight: 500;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 30px;
`;

const SpeakerCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 40px;
  border: 1px solid rgba(8, 45, 74, 0.15);
  box-shadow: 0 8px 24px rgba(8, 45, 74, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: #082D4A;
    box-shadow: 0 12px 28px rgba(8, 45, 74, 0.12);
  }
`;

const Number = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: #0B4C6F;
  margin-bottom: 10px;
`;

const SpeakerName = styled.h3`
  font-size: 1.6rem;
  font-weight: 700;
  color: #082D4A;
  margin-bottom: 6px;
`;

const Institution = styled.p`
  font-size: 1rem;
  color: #CA9D3B;
  margin-bottom: 20px;
`;

const TopicLabel = styled.div`
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 6px;
  color: #0B4C6F;
  letter-spacing: 0.5px;
`;

const Topic = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #727679ff;
  line-height: 1.45;
`;


export default KeynoteSpeakers;
